const styles = {
    table: { width: "100%", minWidth: 650, overflowX: "auto" },
    tableHead: { backgroundColor: "#F0F1F5" },
    tableCell: (colorPallet: any) => ({
        border: `1px solid ${colorPallet.borderColor}`,
        paddingY: "2px !important",
        paddingLeft: "8px !important",
    }),
    batchNumberCell: (colorPallet: any) => ({
        border: `1px solid ${colorPallet.borderColor}`,
        paddingY: "2px !important",
        paddingLeft: "8px !important",
        color: "#0A8DD0",
    }),
    lineThrough: { textDecoration: "line-through" },
    flexBox: { display: "flex", alignItems: "center", gap: 1 },
    rootBox: {
        p: 2,
        mx: 2,
    },
    loadingBox: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "45vh",
    },
    actionBox: {
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        whiteSpace: "nowrap",
    },
};
export default styles;